var commerce = {};
module['exports'] = commerce;
commerce.color = require("./color");